import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

const NavContext = createContext();

function useNav() {
  return useContext(NavContext);
}

const NavProvider = ({ children }) => {
  
  const [navShouldCollapse, setNavShouldCollapse] = useState(false);

  // Value to be passed to provider
  const value = useMemo(() => ({
    navShouldCollapse,
    setNavShouldCollapse
  }), [navShouldCollapse, setNavShouldCollapse]);

  return (
    <NavContext.Provider value={value}>
      {children}
    </NavContext.Provider>
  );
};

export { NavProvider, useNav };
